import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

// SOURCE: https://gist.github.com/dphrag/4db3b453e02567a0bb52592679554a5b
const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
        if (isSubmitting && !isValidating) {
            const keys = Object.keys(errors);
            if (keys.length > 0) {
                const selector = `[name=${keys[0]}]`;
                const errorElement = document.querySelector(selector);
                if (errorElement) {
                    errorElement.scrollIntoView({behavior: "smooth", block: "center"})
                    errorElement.focus();
                }
            }
        }
    }, [errors, isSubmitting, isValidating]);

    return null;
};

export default FocusError;